import { useTranslation } from 'react-i18next';
import CategoryColorIndicator from '~/components/data-display/CategoryColorIndicator/CategoryColorIndicator';
import SimpleTooltip from '~/components/data-display/SimpleTooltip';
import { HStack } from '~/components/layout/Stack';
import Text from '~/components/typographies/Text';
import useCategoryColor from '~/hooks/useCategoryColor';
import { useEllipsisTooltip } from '~/hooks/useEllipsisTooltip';
import { Category, Subcategory } from '~/types/category';
import { isDefined } from '~/types/typeGuards';
import styles from './CategoryItem.module.scss';

const CategoryItem = ({
  category,
  subcategory,
  fullWidth = true,
}: {
  category?: Category;
  subcategory?: Subcategory;
  fullWidth?: boolean;
}) => {
  const { t } = useTranslation();
  const colorConfig = useCategoryColor(category ?? null);
  const getCategoryLabel = (category: Category, subcategory?: Subcategory) =>
    [category.name, subcategory?.name].filter(isDefined).join(' / ');

  const label = category ? getCategoryLabel(category, subcategory) : t('UNCATEGORISED');
  const { ref: labelRef, title } = useEllipsisTooltip(label);

  return (
    <HStack gap={1} align="center" style={{ width: fullWidth ? '100%' : 'auto' }}>
      <CategoryColorIndicator size="small" categoryColor={colorConfig.color} />

      <SimpleTooltip title={title} mode="div" className={styles.categoryTooltip}>
        <Text ref={labelRef} variant="body2" weight="regular" className={styles.categoryLabel}>
          {label}
        </Text>
      </SimpleTooltip>
    </HStack>
  );
};

export default CategoryItem;
